document.addEventListener("DOMContentLoaded", () => {

  const slides = document.querySelectorAll(".product-slide");
  let current = 0;
  const autoplayDelay = 4000; // timp între slide-uri
  const framesDelay = 90;     // viteză rotație
  const moveDistance = 400;   // cât se deplasează sticla în px

  function resetFrames(slide) {
    slide.querySelectorAll(".frame").forEach((f, i) =>
      f.classList.toggle("active-frame", i === 0)
    );
  }

  resetFrames(slides[0]);

  function playFrameSequence(slide, reverse = false) {
    return new Promise(resolve => {
      const frames = slide.querySelectorAll(".frame");
      let i = reverse ? frames.length - 1 : 0;

      function nextFrame() {
        frames.forEach(f => f.classList.remove("active-frame"));
        frames[i].classList.add("active-frame");

        i += reverse ? -1 : 1;

        if (i < 0 || i >= frames.length) return resolve();
        setTimeout(nextFrame, framesDelay);
      }

      nextFrame();
    });
  }

  async function switchProduct(dir = 1) {
    const oldSlide = slides[current];
    const nextIndex = (current + dir + slides.length) % slides.length;
    const newSlide = slides[nextIndex];

    const rotateReverse = dir === 1;
    const rotateNewReverse = dir === 1;

    // animație sticlă care iese
    playFrameSequence(oldSlide, rotateReverse);

    gsap.to(oldSlide, {
      x: dir === 1 ? moveDistance : -moveDistance,
      duration: 2,
      ease: "power1.out"
    });

    gsap.to(oldSlide, {
      opacity: 0,
      duration: 0.8,
      delay: 0.3 // începe fade-out cu 0.3s mai târziu
    });

    // setup slide nou
    newSlide.classList.add("active");
    gsap.set(newSlide, {
      x: dir === 1 ? -moveDistance : moveDistance,
      opacity: 1
    });

    // rotație slide nou
    playFrameSequence(newSlide, rotateNewReverse);

    await gsap.to(newSlide, {
      x: 0,
      opacity: 1,
      duration: 2,
     ease: "power1.out",
    });

    // cleanup
    oldSlide.classList.remove("active");
    gsap.set(oldSlide, { x: 0 });

    current = nextIndex;
  }

  // 🔥 AUTOPLAY — schimbă slide-ul automat
  setInterval(() => switchProduct(1), autoplayDelay);

});
